import { render, staticRenderFns } from "./Ripple.vue?vue&type=template&id=32b35281&"
import script from "./Ripple.vue?vue&type=script&lang=js&"
export * from "./Ripple.vue?vue&type=script&lang=js&"
import style0 from "./Ripple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports